// Municipal Collectionz marketing site: every link, contact detail and price in one place.
// Pages marked `placeholder: true` show the "coming soon" page until they're built.

export const BRAND = {
  top: "Municipal",
  bottom: "COLLECTIONZ",
  name: "Municipal Collectionz",
  tagline:
    "One platform where your city collects every dollar residents owe it, and handles the requests that come with them.",
};

export const CONTACT = {
  email: "mike@municipalcollectionz.com",
  phoneLabel: "(781) 299-4999",
  phoneHref: "tel:+17812994999",
  place: "United States",
};

// App bar links (desktop) and drawer links (mobile).
export const NAV_LINKS = [
  { to: "/", label: "Home", icon: "home", exact: true },
  { to: "/why", label: "Why Municipal Collectionz", icon: "spark" },
  { to: "/features", label: "Features", icon: "grid" },
  { to: "/about", label: "About", icon: "info" },
  { to: "/blog", label: "Blog", icon: "news" },
];

export const FOOTER_COLUMNS = [
  {
    title: "Company",
    links: [
      { to: "/why", label: "Why Municipal Collectionz" },
      { to: "/features", label: "Features" },
      { to: "/about", label: "About Us" },
      { to: "/blog", label: "Blog" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/documentation", label: "Documentation" },
      { to: "/help", label: "Help Center" },
      { to: "/contact", label: "Contact Us" },
      { to: "/demo", label: "Request Demo" },
      { to: "/login", label: "Client Portal" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/cookies", label: "Cookie Policy" },
      { to: "/security", label: "Security" },
    ],
  },
];

// Pages still to build. Each one renders ComingSoonView with this title and line.
// Why, Features, About and Blog are built; Login, Privacy, Terms and Cookies are your existing pages.
export const PLACEHOLDER_PAGES = [
  { path: "/contact", name: "contact", title: "Contact Us", blurb: "Reach our team by email or phone." },
  { path: "/security", name: "security", title: "Security", blurb: "How we protect payments, records and accounts." },
];

// Blog categories (staff blog manager and the public blog).
// Blog bylines. Each post stores authorName, authorTitle (shown under the name)
// and authorBadge (a small label next to the name). Edit the lists to suit.
export const BLOG_BADGES = ["CEO", "Founder", "Team"];
export const BLOG_AUTHOR_TITLES = ["Founder & CEO", "CEO", "Head of Customer Success", "Implementation Lead", "Municipal Collectionz Team"];

// The byline to show for a post, including posts saved before bylines could be edited.
export function postByline(post = {}) {
  const legacyCEO = post.authorTitle === "CEO" && post.authorBadge === undefined;
  const title = legacyCEO || post.authorTitle === "Staff" ? "" : post.authorTitle || "";
  return {
    name: post.authorName || "Municipal Collectionz",
    title,
    badge: post.authorBadge !== undefined ? post.authorBadge || "" : legacyCEO ? "CEO" : "",
  };
}

export const BLOG_CATEGORIES = ["Guides for Treasurers", "Parking & Enforcement", "Resident Experience", "Product Updates", "Announcements"];

// Pricing from the business plan. Edit here; the home page reads it.
export const PRICING = {
  platformFee: "$1.50",
  // Covers Stripe's standard US pricing (card 2.9% + 30¢; bank 0.8%, at most $5).
  cardFee: "2.95% + $0.30",
  bankFee: "0.8%, up to $5",
  contract: "3-year agreement, billed yearly, with two optional 1-year renewals",
  tiers: [
    { size: "Under 10,000 people", setup: "$10,000", yearly: "$12,000" },
    { size: "10,000 to 50,000", setup: "$25,000", yearly: "$30,000", popular: true },
    { size: "50,000 to 150,000", setup: "$40,000", yearly: "$60,000" },
    { size: "Over 150,000", setup: "Custom", yearly: "Custom" },
  ],
  feeOnly: {
    title: "No budget set aside?",
    fee: "$2.50",
    text: "Skip the subscription. Residents pay a $2.50 platform fee per online payment, plus the usual card or bank fee, and your setup fee is smaller.",
  },
};

export const POPULATION_OPTIONS = [
  "Under 5,000",
  "5,000 - 10,000",
  "10,000 - 25,000",
  "25,000 - 50,000",
  "50,000 - 100,000",
  "100,000 - 250,000",
  "250,000+",
];

// Stripe publishable key for Municipal Collectionz. This is the public key, safe to ship in the browser.
// (The secret key never goes here; it lives only in Firebase secrets as STRIPE_SECRET_KEY.)
export const STRIPE_PUBLISHABLE_KEY =
  process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_live_51UTltLENNw2rSxSInLqVF4nWfaDOwCHM0EMAkWRb4eBK80hazZkvddVzBq1oDQ77xdmuXBsB034V23qJSCUNEvPf00teceARLu";